
































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { Mixin } from "@/core/mixins/mixin";
import MySwipers from "@/components/MySwiper.vue";
import { Image, Row, Col, Icon, Tabs, Tab } from "vant";
import { BillboardInfoDtos } from "@/shims-video";
import { monitorEvent } from "@/utils/youMengMonitor";
import { zhugeTrack } from "@/utils";

@Component({
  components: {
    [Image.name]: Image,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    MySwipers,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
  },
})
export default class HotRanks extends Mixins(Mixin) {
  @Prop()
  public rankList!: BillboardInfoDtos;
  @Prop({ default: 0 })
  public rankIndex!: number;
  type = "slide";
  toursList: any = [];
  coverflowEffect = {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 1,
    slideShadows: false,
  };
  active = "0";
  rankListTitlelist = [1, 2];
  gotoRankDetails(): void {
    let rankList = this.rankList;
    monitorEvent("Home_ClickPolularList", "点击榜单详情", rankList.title || ""); // 埋点：点击榜单详情
    // this.$router.push(`/rank-detail/${rankList.billboardId}/${this.rankIndex}`);
    this.$router.push(`/rank-list`);
  }
  goToDetail(item: any): void {
    zhugeTrack("楼层点击", {
      楼层名称: item.floorNameForIo,
      楼层ID: item.floorIdForIo,
      榜单名称: item.billboardTitleForIo,
      榜单ID: item.billboardIdForIo,
      项目名称: item.productName,
      项目ID: item.productId,
    });
    this.goToProjectDetail(item.productId, item.tourId, item.tour);
  }
}
